import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { compareStrings } from '@cbridge-utils/object';
import { NodeAction } from './node.action';
import { nodeInitialState } from './node.constant';

export const nodeReducer = reducerWithInitialState(nodeInitialState)
  .case(NodeAction.loadList.started, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Started,
    };
  })
  .case(NodeAction.loadList.done, (state, payload) => {
    return {
      ...state,
      list: [...payload.result.nodeList].sort((a, b) => compareStrings(a.name, b.name)),
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(NodeAction.loadList.failed, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Failed,
    };
  })
  .case(NodeAction.select, (state, payload) => {
    const { nodeId } = payload;

    return {
      ...state,
      selected: nodeId,
    };
  })
  .case(NodeAction.toggleSelect, (state, payload) => {
    const { nodeId } = payload;

    return {
      ...state,
      selected: state.selected === nodeId ? undefined : nodeId,
    };
  })
  .case(NodeAction.clearSelect, (state) => {
    return {
      ...state,
      selected: undefined,
    };
  })
  .case(NodeAction.remove.done, (state, { result: { nodeId } }) => {
    return {
      ...state,
      list: state.list.filter((item) => item.nodeId !== nodeId),
      selected: state.selected === nodeId ? state.list[0]?.nodeId : state.selected,
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(NodeAction.destroy, () => ({
    ...nodeInitialState,
  }));
